import { ALL_ROLES, EDUCATOR_ROLES } from "./roles";

// Home / Wellness
import HomeScreen from "@/screens/HomeScreen/HomeScreen";
import HowDoIfeel from "@/screens/HomeScreen/HowDoIFeel";
import Actions from "@/screens/HomeScreen/Actions";
import PerformAction from "@/screens/HomeScreen/PerformAction";
import Congratulations from "@/screens/HomeScreen/Congratulations";
import AudioScreen from "@/screens/HomeScreen/AudioScreen";

// Breathing
import DeepBreathe from "@/screens/HomeScreen/DeepBreathe";
import DeepBreatheCopy from "@/screens/HomeScreen/DeepBreatheCopy";
import DeepBreathe2 from "@/screens/HomeScreen/DeepBreathe2";
import DeepBreathe3 from "@/screens/HomeScreen/DeepBreathe3";

// Grounding
import SeeAndHear from "@/screens/HomeScreen/SeeAndHear";
import SeeAndHear2 from "@/screens/HomeScreen/SeeAndHear2";

// Profile
import OptionsScreen from "@/screens/OptionsScreen";
import ResourcesPage from "@/screens/Resources/ResourcesPage";
import SelfCareChallengePage from "@/screens/SelfCareChallenge/SelfCareChallengePage";

// Dashboards
import StudentDashboard from "@/screens/Dashboards/StudentDashboard";
import EducatorDashboard from "@/screens/Dashboards/EducatorDashboard";
import StudentSupports from "@/screens/Dashboards/StudentSupports/StudentSupports";

export const ROUTE_REGISTRY = [
  {
    path: "/",
    component: HomeScreen,
    roles: ALL_ROLES,
    props: [],
    requiresBootstrap: true,
    accessRequired: false,
  },
  {
    path: "/optionsscreen",
    component: OptionsScreen,
    roles: ALL_ROLES,
    props: [],
    requiresBootstrap: true,
    accessRequired: false,
  },
  {
    path: "/studentdashboard",
    component: StudentDashboard,
    roles: ALL_ROLES,
    props: [],
    requiresBootstrap: true,
    accessRequired: false,
  },
  {
    path: "/resourcestab",
    component: ResourcesPage,
    roles: ALL_ROLES,
    props: [],
    demoHidden: true,
    accessRequired: false,
  },
  {
    path: "/selfcarechallenge",
    component: SelfCareChallengePage,
    roles: EDUCATOR_ROLES,
    props: [],
    demoHidden: true,
    accessRequired: false,
  },
  {
    path: "/howdoifeel",
    component: HowDoIfeel,
    roles: ALL_ROLES,
    props: [],
    requiresBootstrap: true,
    accessRequired: true,
  },
  {
    path: "/actions",
    component: Actions,
    roles: ALL_ROLES,
    props: ["setWellnessId", "setAchievements", "wellnessIdempotencyKey"],
    requiresBootstrap: true,
    accessRequired: true,
  },
  {
    path: "/performaction",
    component: PerformAction,
    roles: ALL_ROLES,
    props: [],
    requiresBootstrap: true,
    accessRequired: true,
  },
  {
    path: "/congratulations",
    component: Congratulations,
    roles: ALL_ROLES,
    props: ["wellnessId", "achievements", "idempotencyKeyRef"],
    requiresBootstrap: true,
    accessRequired: true,
  },
  {
    path: "/deepbreathe",
    component: DeepBreathe,
    roles: ALL_ROLES,
    props: ["resetIdempotencyKey"],
    requiresBootstrap: true,
    accessRequired: true,
  },
  {
    path: "/deepbreathecopy",
    component: DeepBreatheCopy,
    roles: ALL_ROLES,
    props: [],
    requiresBootstrap: true,
    accessRequired: true,
  },
  {
    path: "/deepbreathe2",
    component: DeepBreathe2,
    roles: ALL_ROLES,
    props: [],
    requiresBootstrap: true,
    accessRequired: true,
  },
  {
    path: "/deepbreathe3",
    component: DeepBreathe3,
    roles: ALL_ROLES,
    props: [],
    requiresBootstrap: true,
    accessRequired: true,
  },
  {
    path: "/seeandhear",
    component: SeeAndHear,
    roles: ALL_ROLES,
    props: [],
    requiresBootstrap: true,
    accessRequired: true,
  },
  {
    path: "/seeandhear2",
    component: SeeAndHear2,
    roles: ALL_ROLES,
    props: [],
    accessRequired: true,
  },
  {
    path: "/audioscreen",
    component: AudioScreen,
    roles: ALL_ROLES,
    props: [],
    accessRequired: true,
  },
  {
    path: "/dashboard",
    component: EducatorDashboard,
    roles: EDUCATOR_ROLES,
    props: [],
    requiresBootstrap: true,
    accessRequired: false,
  },
  {
    path: "/studentsupports",
    component: StudentSupports,
    roles: EDUCATOR_ROLES,
    props: [],
    requiresBootstrap: true,
    accessRequired: false,
  },
];
